import {createContext, useContext} from 'react';
import {IPagination} from 'core/models';
import {IGetCatalogTransformedResponse} from 'modules/products/services';
import {ISortingOption} from 'hooks/product/useSortingControl';
import {SORT_LIST} from 'modules/products/constants';
import once from 'lodash/once';
import {ISearchMeta} from 'modules/products/types';

export type TListingTypes = 'PLP' | 'SEARCH' | 'STOCKS' | 'STOCK_DISCOUNT' | 'STOCK_X';

export interface IProductListContext<IProduct> {
    isFetching: boolean;
    isLoading: boolean;
    isLoadingPrev: boolean;
    isLoadingNext: boolean;
    list: IProduct[];
    pagination: IPagination & {onChange?: (pageNumber: number) => void};
    hasMoreProductsOnTop: boolean;
    handleLoadPrev: () => void;
    handleLoadNext: () => void;
    handleSort: ({value}: {value: string}) => void;
    handleSetPage: (pageNumber: number) => void;
    meta?: IGetCatalogTransformedResponse['meta'] | null;
    seo?: IGetCatalogTransformedResponse['seo'] | null;
    searchMeta?: ISearchMeta;
    view?: 'tile' | 'list';
    handleChangeView?: (view: 'list' | 'tile') => void;
    sortingList: ISortingOption[];
    pageType: TListingTypes;
}

export const PAGINATION_DEFAULT = {pageNumber: 1, pageSize: 33, totalCount: 0};

export const createListingContext = once(<Product>() =>
    createContext(<IProductListContext<Product>>{
        handleLoadPrev: () => {},
        handleLoadNext: () => {},
        handleSetPage: () => {},
        handleSort: () => {},
        hasMoreProductsOnTop: false,
        isFetching: false,
        isLoading: false,
        isLoadingNext: false,
        isLoadingPrev: false,
        list: [],
        pagination: PAGINATION_DEFAULT,
        sortingList: SORT_LIST,
        pageType: 'PLP',
    }),
);
export const useListingContext = <T>() => useContext(createListingContext<T>());
